import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isEmpty, trim } from 'lodash';
import { ReplaceTransition, CSSTransition } from 'react-transition-group';
import { withTranslation } from 'react-i18next';
import { ANIMATIONS } from 'utils/Animations';

class WebNoteAdd extends React.Component {
  static propTypes = {
    params: PropTypes.object.isRequired,
    onAdd: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = { isAdd: false, value: '' };
  }

  onAdd = () => {
    this.setState({ isAdd: true, value: '' });
  }

  onCancel = () => {
    this.setState({ isAdd: false });
  }

  onChange = (e) => {
    this.setState({ value: e.target.value });
  }

  onCreate = () => {
    const body = this.state.value;
    this.setState({ isAdd: false });
    if (!isEmpty(trim(body))) this.props.onAdd(this.props.params, body);
  }

  render() {
    const { t } = this.props;
    const isAdd = this.state.isAdd;
    const clsAdd = classNames('o-sp-button o-sp-button--note o-sp-button--primary',
      { 'u-disabled': isEmpty(trim(this.state.value)) }
    );
    return (
      <ReplaceTransition in={isAdd}>
        <CSSTransition timeout={{ enter: ANIMATIONS.in, exit: ANIMATIONS.out }} classNames='a-webnote-slide'>
          <div>
            <textarea value={this.state.value} onChange={this.onChange} />
            <div className='row align-middle'>
              <div className='column shrink'>
                <a className={clsAdd} onClick={this.onCreate}>{t('notes.addNote')}</a>
              </div>
              <div className='column shrink'>
                <a className='o-sp-button--note cs-txt-link--sp-blue' onClick={this.onCancel}>{t('notes.cancel')}</a>
              </div>
            </div>
          </div>
        </CSSTransition>
        <CSSTransition timeout={{ enter: ANIMATIONS.out, exit: ANIMATIONS.in }} classNames='a-none'>
          <a className='cs-txt-link--sp-blue' onClick={this.onAdd}>{t('notes.addAnotherNote')}</a>
        </CSSTransition>
      </ReplaceTransition>
    );
  }
}

export default withTranslation()(WebNoteAdd);
